<template>
	<el-row class="container">
		<el-col :span="24" class="header">
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				{{collapsed?'':sysName}}
			</el-col>
			<!--<el-col :span="10"> 
				<div class="tools" @click.prevent="collapse">
					<i class="fa fa-align-justify"></i>
				</div>
			</el-col>-->
			<el-col :span="4" class="userinfo">
				<el-dropdown trigger="click">
					<span class="el-dropdown-link userinfo-inner"><img :src="data.avatar" />{{data.guildName}}</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'">
				<!--导航菜单-->
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed">
					<template v-for="(item,index) in routerList">
						<template v-if="!item.hidden">
							<el-submenu :index="index+''" v-if="!item.leaf" :key="index">
								<template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
								<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path">
									<template v-if="!child.hidden">{{child.name}}</template>
								</el-menu-item>
							</el-submenu>
							<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path" :key="index"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
						</template>
					</template>
				</el-menu>
				<!--导航菜单-折叠后-->
				<ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
					<li v-for="(item,index) in routerList" :key="index" class="el-submenu item">
						<template v-if="!item.hidden">
							<template v-if="!item.leaf">
								<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
								<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"> 
									<li v-for="child in item.children" :key="child.path" class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">
										<template v-if="!child.hidden">{{child.name}}</template>
									</li>
								</ul>
							</template>
							<template v-else>
								<li class="el-submenu">
									<div class="el-submenu__title el-menu-item" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
								</li>
							</template>
						</template>
					</li>
				</ul>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
	</el-row>
</template>

<script>
	import Cookies from 'js-cookie';
	export default {
		data() {
			return {
				sysName:'Home',
				collapsed:false,
				data:'',
				routerList:[]
			}
		},
		methods: {
			goBack() {
				this.$router.go(-1);
            },
			onSubmit() {
				console.log('submit!');
			},
			handleopen() {
				//console.log('handleopen');
			},
			handleclose() {
				//console.log('handleclose');
			},
			handleselect: function (a, b) {
			},
			//退出登录
			logout() {
			  this.$confirm('确认退出吗?', '提示').then(() => {
			    sessionStorage.removeItem('user');
				this.$store.commit('changeToken', '');
				this.$store.commit('changeUser', '');
			    console.log('退出登录，清除 sessionStorage');
			    this.$router.push('/ghdenglu');
			  });
			},
			//折叠导航栏
			collapse:function(){
				
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			}
		},
		mounted() {
			this.routerList = this.$router.options.routes
			if(Cookies.get('user')){
				this.data = JSON.parse(Cookies.get('user'))
				console.log(this.data)
				this.routerList.forEach((v,i)=>{
					if (v.id == 2) {
						v.hidden = false
					}
					if (v.id == 3) {
						v.hidden = false
					}
					if (v.id == 4) {
						v.hidden = false
					}
					if (v.id == 5) {
						v.hidden = false
					}
					if (v.id == 6) {
						v.hidden = false
					}
					if (v.id == 7) {
						v.hidden = false
					}
				})
				this.routerList.forEach((v,i)=>{
					if (this.data.adminGuildBtnInfo.btn2 == 0 && v.id == 2) {
						v.hidden = true
					}
					if (this.data.adminGuildBtnInfo.btn3 == 0 && v.id == 3) {
						v.hidden = true
					}
					if (this.data.adminGuildBtnInfo.btn4 == 0 && v.id == 4) {
						v.hidden = true
					}
					if (this.data.adminGuildBtnInfo.btn5 == 0 && v.id == 5) {
						v.hidden = true
					}
					if (this.data.adminGuildBtnInfo.btn6 == 0 && v.id == 6) {
						v.hidden = true
					}
					if (this.data.adminGuildBtnInfo.btn7 == 0 && v.id == 7) {
						v.hidden = true
					}
				})
				this.routerList.forEach(v => {
				    const btnKey = `btn${v.id}`;
				    if (this.data.adminGuildBtnInfo[btnKey] === 0) {
				        v.hidden = true;
				    }
				});
			}
			console.log(this.routerList,this.$router.options.routes)

		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: $color-primary;
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 35px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 40px;
						height: 40px;
						border-radius: 5px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				//width:230px;
				height:60px;
				font-size: 18px;
				padding-left:20px;
				padding-right:20px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:200px;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 200px;
				width: 200px;
				overflow-y: auto;
				overflow-x: hidden;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				flex:0 0 200px;
				width: 200px;
				.el-menu-vertical-demo{
					width:100% !important;
				}
			}
			.content-container {
				// background: #f1f2f7;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow-y: auto;
				padding: 20px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}
	.el-message-box__message p {
		margin-left: -1px;
	}
</style>


// WEBPACK FOOTER //
// Home.vue?304da388